export const detailUrl = ({ id }) => {
  return `/report-errands/detail/${id}/errand`;
};
